import { getCredentialsStore, getAccountStore } from '../storage/stores';
import { setApiCredentials } from './authentication';
import { getExtensionClientCredentials } from '../constants';
import { setupApiAccount } from './account';

export const setupQApi = async () => {
  setupCredentials();
  await setupAccount();
};

const setupCredentials = () => {
  /**
   * check if credentials could be undefined
   * @see {@link https://qustodio.atlassian.net/browse/CHR-167 | Jira ticket}
   */
  const credentials = getCredentialsStore().get();
  const extensionClientCredentials = getExtensionClientCredentials();
  const clientCredentials = {
    client_id: extensionClientCredentials.client_id,
    client_secret: extensionClientCredentials.client_secret,
  };

  const { accessToken, refreshToken } = credentials || {};
  setApiCredentials({
    accessToken,
    refreshToken,
    clientCredentials,
    onTokensChange: getCredentialsStore().refreshTokens,
  });
};

const setupAccount = async () => {
  const accountData = getAccountStore().get();
  if (!accountData) {
    throw new Error('Account store not properly initialized!');
  }

  const { accountId, accountUid, masterAccountId, masterAccountUid } =
    accountData;
  setupApiAccount({ accountId, accountUid, masterAccountId, masterAccountUid });
};
